import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from './shared/ui/loading/loading.component';
import { ChatWidgetService } from './core/service/chat-widget.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  // Eagerly initialize to start loading the correct bot based on auth state
  private readonly _chatWidget = inject(ChatWidgetService);
}
